@if (item) {
<app-expand-menu [item]="item" (actionClicked)="onActionClicked($event)" />
}
